import DatapharmTable from '@components/DatapharmTable/DatapharmTable';
import { mapToProductGroupData, getProductGroupTableColumnsData } from './helpers';
import { createColumns } from '../../helpers';
import { SubmissionTaskDetailsUnitWrapper } from '../../styles';
import { IProductGroupTable } from './types';
import { HeaderWrapper, TableWrapper } from './styles';
import { TableOverflowContainer } from '@common/styles';
import { LookupWarning } from '../LookupWarning/LookupWarning';

export const ProductGroupTable = ({
  showLookupValidation = false,
  submissionTask,
  productGroup,
  unapprovedSubstances,
  isLoading,
  productGroupChanges,
  onUpdateClick,
  documentAttributes,
  isReadonly,
  onSubstanceManageClick,
}: IProductGroupTable) => {
  isReadonly ||= !submissionTask?.isNewProductGroupSubmission;
  const columnsData = getProductGroupTableColumnsData(productGroupChanges, isReadonly, onUpdateClick);
  const columns = createColumns(columnsData);
  const documents = mapToProductGroupData(submissionTask, productGroup, productGroupChanges, documentAttributes);

  return (
    <div>
      {!isLoading && (
        <SubmissionTaskDetailsUnitWrapper>
          <HeaderWrapper>
            <span>Product group</span>
          </HeaderWrapper>
          <TableWrapper>
            <TableOverflowContainer>
              <DatapharmTable columns={columns} documents={documents!} data-testid="product-group-table" />{' '}
              {showLookupValidation && unapprovedSubstances && unapprovedSubstances.length > 0 && (
                <LookupWarning
                  title="Substances pending approval:"
                  newLookups={unapprovedSubstances}
                  onManageClick={onSubstanceManageClick}
                />
              )}
            </TableOverflowContainer>
          </TableWrapper>
        </SubmissionTaskDetailsUnitWrapper>
      )}
    </div>
  );
};
